/**
 * File topBar.js
 *
 * Handles scroll behavior for page when topbar present
 */

document.addEventListener('DOMContentLoaded', () => {
    const page = document.querySelector('#page');

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length) {
                const topbar = document.querySelector('#tpbr_topbar');
                const hero_animated = document.querySelector('.mo-hero-animated');
                if (hero_animated) {
                    document.querySelector('.main-header-menu').classList.remove('text-color-black');
                    document.querySelector('.main-header-menu').classList.add('text-color-white');
                    document.querySelector('.mobile-menu-toggle-icon').classList.remove('color-black');
                    document.querySelector('.mobile-menu-toggle-icon').classList.add('color-white');
                }
                const header = document.querySelector('.ast-stick-primary-below-wrapper');
                if (topbar) {
                    
                    const scrollPoint = topbar.offsetHeight;
                    if (window.scrollY < 150) {
                        topbar.classList.add('is-fixed-at-top');
                    }
                    var lastScrollTop = window.scrollY;
                    const handleScroll = () => {
                        if (window.scrollY < 150) {
                            if (window.scrollY < lastScrollTop) {
                                window.scrollTo({top: 0, behavior: 'smooth'});
                            }
                            topbar.classList.add('is-fixed-at-top');
                        } else {
                            topbar.classList.remove('is-fixed-at-top');
                        }
                        lastScrollTop = window.scrollY;
                    };

                    window.addEventListener('scroll', handleScroll);

                    observer.disconnect();
                }
            }
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
});